import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class NotFound extends Component {
  render() {
    return (
      <div className="page-wrapper-custom d-flex flex-column align-items-center justify-content-center text-center p-5 min-vh-100">
        <div className="search-bar-card p-5" style={{ maxWidth: '500px' }}>
          <div style={{ fontSize: '4.5rem', marginBottom: '16px' }}>🍽️</div>
          <h1 style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: '2.5rem', color: 'var(--color-text)' }}>
            404 - Not Found
          </h1>
          <p style={{ color: 'var(--color-text-muted)', fontSize: '1.05rem', margin: '16px 0 24px 0' }}>
            Ops! A página que você está procurando parece ter desaparecido da nossa cozinha.
          </p>
          <Link to="/comidas" className="default-button orange d-inline-block px-4 py-3" style={{ borderRadius: '12px', textDecoration: 'none' }}>
            &larr; Voltar para o Menu Principal
          </Link>
        </div>
      </div>
    );
  }
}

export default NotFound;
